import React from 'react';
import { ArrowUpRightIcon, BookOpenIcon, Clock3Icon, MapPinnedIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { SectionHeading } from '../components/SectionHeading';
type FeaturedGuide = {
  title: string;
  date: string;
  category: string;
  image: string;
  alt: string;
};
const featuredGuides: FeaturedGuide[] = [{
  title: "Everest Base Camp: the considered first-timer's guide",
  date: 'Updated 10th July 2026',
  category: 'EVEREST',
  image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=1200&q=85',
  alt: 'Snow-covered Himalayan summit above a mountain valley'
}, {
  title: 'A slow journey through the Annapurna foothills',
  date: 'Updated 8th July 2026',
  category: 'ANNAPURNA',
  image: 'https://images.unsplash.com/photo-1571401835393-8c5f353283d2?auto=format&fit=crop&w=1200&q=85',
  alt: "Hiker walking on a trail in Nepal's mountain landscape"
}, {
  title: 'Pokhara beyond the lake: trails, tea and quiet mornings',
  date: 'Updated 5th July 2026',
  category: 'POKHARA',
  image: 'https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=1200&q=85',
  alt: 'Traditional architecture framed by the Nepalese landscape'
}];
const guideEntries = ['How to Reach Everest Base Camp Trek - Updated 10th July 2026', 'Flight to Lukla consideration - updated 7th July 2026', 'When is the best time to trek in Nepal? - Updated 4th July 2026', 'A practical packing list for Himalayan treks - Updated 1st July 2026', 'Understanding permits for the Annapurna region - Updated 28th June 2026', 'Pokhara to Poon Hill: planning the classic short trek - Updated 24th June 2026', 'Acclimatisation on the Everest trail: a day-by-day approach - Updated 19th June 2026', 'Langtang Valley Trek: what to expect - Updated 15th June 2026', 'Choosing the right guide and porter in Nepal - Updated 11th June 2026', 'Tea houses in Nepal: food, rooms and trail etiquette - Updated 6th June 2026'];
export function Guides() {
  return <div className="min-h-screen bg-[#f8f5ed] text-[#17362e]" data-id="element-516">
      <Header data-id="element-517" />

      <main data-id="element-518">
        <section className="relative flex min-h-[500px] items-end overflow-hidden bg-[#17362e] pb-16 pt-28 text-white sm:min-h-[580px] sm:pb-20" data-id="element-519">
          <img src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=2200&q=90" alt="Himalayan mountain ridges above a Nepal trekking trail" className="absolute inset-0 h-full w-full object-cover opacity-75" data-id="element-520" />
          <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(10,32,25,0.8),rgba(10,32,25,0.16)_72%),linear-gradient(0deg,rgba(10,32,25,0.72),transparent_60%)]" data-id="element-521" />
          <div className="relative mx-auto w-full max-w-[1180px] px-5 sm:px-8" data-id="element-522">
            <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.3em] text-[#c8dfbd]" data-id="element-523">
              <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-524" />
              Field notes from Nepal
            </p>
            <h1 className="mt-5 max-w-3xl font-serif text-5xl leading-[0.98] sm:text-7xl" data-id="element-525">
              Guides for journeys
              <br data-id="element-526" />
              <i className="font-normal" data-id="element-527">with more depth.</i>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-7 text-white/85" data-id="element-528">
              Practical trail knowledge, thoughtful itineraries and local
              perspective for travelling through Nepal well.
            </p>
          </div>
        </section>

        <section className="bg-[#e7e7db] py-20 sm:py-28" data-id="element-529">
          <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-530">
            <SectionHeading eyebrow="Featured reading" title="Start with the trail" data-id="element-531" />
            <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-532">
              {featuredGuides.map(guide => <article key={guide.title} className="group flex flex-col bg-[#f8f5ed]" data-id="element-533">
                  <Link to="/guides" className="block overflow-hidden focus:outline-none focus:ring-2 focus:ring-[#17362e] focus:ring-offset-4" aria-label={`Read ${guide.title}`} data-id="element-534">
                    <img src={guide.image} alt={guide.alt} className="h-64 w-full object-cover transition duration-700 group-hover:scale-[1.02]" data-id="element-535" />
                  </Link>
                  <div className="flex flex-1 flex-col p-6" data-id="element-536">
                    <div className="flex flex-wrap gap-x-3 gap-y-2 text-[10px] font-bold uppercase tracking-[0.13em] text-[#65766a]" data-id="element-537">
                      <span className="text-[#4f8057]" data-id="element-538">{guide.category}</span>
                      <span data-id="element-539">{guide.date}</span>
                    </div>
                    <h2 className="mt-4 font-serif text-2xl leading-snug" data-id="element-540">
                      <Link to="/guides" className="focus:outline-none focus:underline" data-id="element-541">
                        {guide.title}
                      </Link>
                    </h2>
                    <Link to="/guides" className="mt-6 inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.16em] text-[#17362e] focus:outline-none focus:underline" data-id="element-542">
                      Read guide
                      <ArrowUpRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" data-id="element-543" />
                    </Link>
                  </div>
                </article>)}
            </div>
          </div>
        </section>

        <section className="py-20 sm:py-28" data-id="element-544">
          <div className="mx-auto grid max-w-[1180px] gap-10 px-5 sm:px-8 lg:grid-cols-[0.7fr_1.3fr]" data-id="element-545">
            <div data-id="element-546">
              <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.24em] text-[#a66e2e]" data-id="element-547">
                <MapPinnedIcon className="h-4 w-4" aria-hidden="true" data-id="element-548" />
                The journal
              </p>
              <h2 className="mt-4 font-serif text-4xl leading-tight sm:text-5xl" data-id="element-549">
                More useful reads for the road.
              </h2>
              <p className="mt-6 max-w-md text-lg leading-8 text-[#52635a]" data-id="element-550">
                Clear, current guidance to help you prepare with confidence
                before you arrive in the mountains.
              </p>
            </div>

            <ol className="divide-y divide-[#cfd3c8] border-y border-[#cfd3c8]" data-id="element-551">
              {guideEntries.map((entry, index) => <li key={entry} data-id="element-552">
                  <Link to="/guides" className="group flex items-start gap-4 py-5 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#17362e] sm:gap-6" aria-label={`Read guide: ${entry}`} data-id="element-553">
                    <span className="pt-0.5 font-serif text-xl text-[#a66e2e]" data-id="element-554">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className="flex-1 text-base font-medium leading-6 text-[#17362e] transition-colors group-hover:text-[#4f8057]" data-id="element-555">
                      {entry}
                    </span>
                    <ArrowUpRightIcon className="mt-1 h-4 w-4 shrink-0 text-[#718074] transition-colors group-hover:text-[#4f8057]" aria-hidden="true" data-id="element-556" />
                  </Link>
                </li>)}
            </ol>
          </div>
        </section>

        <section className="bg-[#c8dfbd] px-5 py-12 text-[#17362e] sm:px-8 lg:px-12" data-id="element-557">
          <div className="mx-auto flex max-w-[1180px] items-start gap-4" data-id="element-558">
            <Clock3Icon className="mt-1 h-5 w-5 shrink-0 text-[#4f8057]" aria-hidden="true" data-id="element-559" />
            <p className="max-w-3xl text-sm leading-6 text-[#40564a]" data-id="element-560">
              Our guides are reviewed regularly so that trail details, seasonal
              considerations and logistics stay useful.
            </p>
          </div>
        </section>
      </main>

      <Footer data-id="element-561" />
    </div>;
}